module.exports = __webpack_public_path__ + "img/DW365-036.784fb497.jpg";